import { TextFieldInput } from "@smart/itops-sb-design-system-dom";

import { FieldGroup } from "./field-group";
import { Label } from "./label";
import { FieldProps, FieldWrapper } from "./wrapper";
import { fieldName } from "../../hooks";

export const NumberField = ({
  field,
  index,
  innerRef,
  value,
  error,
  loading,
  disabled,
  onChange,
  onBlur,
}: FieldProps<HTMLInputElement>) => {
  const id = fieldName({ field, index });
  const errorId = fieldName({ field, index, suffix: "error" });

  return (
    <FieldWrapper disabled={disabled} isLoading={loading}>
      <FieldGroup
        id={id}
        hint={field.hint ?? undefined}
        label={<Label {...field} />}
      >
        <TextFieldInput
          ref={innerRef}
          id={id}
          name={id}
          error={!!error}
          message={error ?? undefined}
          maxLength={16}
          aria-invalid={!!error}
          aria-errormessage={errorId ?? undefined}
          value={value?.toString().replace(/[^\d]/g, "") ?? ""}
          inputMode="numeric"
          pattern="\d*"
          onChange={(e) => {
            const asString = e.target.value.replace(/[^\d]/g, "");
            const asNumber = parseInt(asString, 10);

            onChange(Number.isNaN(asNumber) ? null : asNumber);
          }}
          onBlur={onBlur}
        />
      </FieldGroup>
    </FieldWrapper>
  );
};
